/**
 * Auftragsverfolgung — Root App
 *
 * Phase 1: Placeholder-Page mit Hinweis auf Phasenfortschritt.
 * Phase 7 wird MainPage mit Karten-Grid, Filter und Detail-Drawer fuellen.
 */

import MainPage from './pages/MainPage';

export default function AuftragsverfolgungApp() {
  return <MainPage />;
}
